import { useQuery } from '@tanstack/react-query';
import { goodsService } from 'shared/src/api';
import { useGoodsSno } from '../../../hooks/useGoodsSno';
import { queryKey } from '../../../constant/queryKey';
import { convertGoodsLikeItemToGoodsData } from '../utils/convertGoodsLikeItemToGoodsData';

export const useGoodsLikeRecommend = () => {
  const goodsSno = useGoodsSno();

  return useQuery({
    queryKey: queryKey.goodsLikeRecommend(goodsSno),
    queryFn: () => {
      return goodsService.getGoodsLikeRecommend(goodsSno);
    },
    select: data => {
      return {
        ...data,
        carousels: data.carousels.map(carousel => {
          return {
            ...carousel,
            item_list: carousel.item_list.map(convertGoodsLikeItemToGoodsData),
          };
        }),
      };
    },
  });
};
